import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  Spinner,
  Form,
  Button,
  ButtonGroup,
  Dropdown,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomNavbar from "../../../../components/CustomNavbar";
import {
  getFuncUsersData,
  getGlobalFuncUserInfo,
} from "../../../../redux/func_ficha_empleados/actions";
import SidebarDashboard from "../../../../components/SidebarDashboard";
import CustomPagint from "../../../../components/CustomPagint";
import userperfil from "../../../../images/userperfil.png";

const FuncStaffInventory = (props) => {
  const filters = [
    { num: 1, id: "codigo", desc: "Código de empleado" },
    { num: 2, id: "nombre", desc: "Nombre de empleado" },
    { num: 3, id: "centro_costo", desc: "Centro de costo" },
    { num: 4, id: "funcion", desc: "Función" },
    { num: 5, id: "puesto", desc: "Puesto" },
    { num: 6, id: "unidad_organizativa", desc: "Unidad organizativa" },
  ];

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState(
    parseInt(props.match.params.searchtype) !== 1
      ? props.match.params.filter
      : ""
  );
  const [show, setShow] = useState(false);
  const [Search, setSearch] = useState(false);
  const [tipoBusqueda, setTipoBusqueda] = useState(
    props.match.params.filterType &&
      filters.find((f) => f.num === parseInt(props.match.params.filterType))
      ? filters.find((f) => f.num === parseInt(props.match.params.filterType))
      : filters[0]
  );

  //redux
  const dispatch = useDispatch();
  const loading = useSelector((store) => store.funcTabEmployeed.loading);
  const data = useSelector((store) => store.funcTabEmployeed.ficha);
  const dataLenght = useSelector((store) => store.funcTabEmployeed.fichaLength);
  const { userRoles } = useSelector((store) => store.auth);
  const pages = Math.ceil(dataLenght / limit);

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.search.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    if (parseInt(props.match.params.searchtype) === 1) {
      getAFuncUsersData(oOffset, limit, e.target.search.value);
    } else {
      getAGlobalFuncUserInfo(oOffset, limit, e.target.search.value);
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setSearch(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    if (parseInt(props.match.params.searchtype) === 1) {
      getAFuncUsersData(oOffset, limit, oSearch);
    } else {
      getAGlobalFuncUserInfo(oOffset, limit, oSearch);
    }
  };

  const getAFuncUsersData = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getFuncUsersData(
        {
          orga: props.match.params.id,
          offset: offs,
          limit: lim,
          // filter: filt,
          filter:
            filt !== ""
              ? JSON.stringify({
                  codigo__icontains:
                    tipoBusqueda.id === "codigo" ? filt : undefined,
                  nombre__icontains:
                    tipoBusqueda.id === "nombre" ? filt : undefined,
                  centro_costo__descripcion__icontains:
                    tipoBusqueda.id === "centro_costo" ? filt : undefined,
                  posicion__descripcion__icontains:
                    tipoBusqueda.id === "funcion" ? filt : undefined,
                  puesto__descripcion_larga__icontains:
                    tipoBusqueda.id === "puesto" ? filt : undefined,
                  unidad_organizativa__nombre__icontains:
                    tipoBusqueda.id === "unidad_organizativa"
                      ? filt
                      : undefined,
                })
              : undefined,
          activo:
            userRoles.includes("jefe") || userRoles.includes("alta_direccion")
              ? "Activo"
              : "",
        },
        parseInt(props.match.params.type)
      )
    );
  const getAGlobalFuncUserInfo = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getGlobalFuncUserInfo(
        {
          offset: offs,
          limit: lim,
          // filter: filt,
          filter:
            filt !== ""
              ? JSON.stringify({
                  codigo__icontains:
                    tipoBusqueda.id === "codigo" ? filt : undefined,
                  nombre__icontains:
                    tipoBusqueda.id === "nombre" ? filt : undefined,
                  centro_costo__descripcion__icontains:
                    tipoBusqueda.id === "centro_costo" ? filt : undefined,
                  posicion__descripcion__icontains:
                    tipoBusqueda.id === "funcion" ? filt : undefined,
                  puesto__descripcion_larga__icontains:
                    tipoBusqueda.id === "puesto" ? filt : undefined,
                  unidad_organizativa__nombre__icontains:
                    tipoBusqueda.id === "unidad_organizativa"
                      ? filt
                      : undefined,
                })
              : undefined,
          activo:
            userRoles.includes("jefe") || userRoles.includes("alta_direccion")
              ? "Activo"
              : "",
          all_empleados:
            props.match.params.type == "allregisters00" ? true : false,
        },
        parseInt(props.match.params.type)
      )
    );

  useEffect(() => {
    if (userRoles && userRoles.length > 0) {
      if (props.match.params.type === "allregisters00") {
        dispatch(
          getGlobalFuncUserInfo(
            {
              offset: offset,
              limit: limit,
              all_empleados: true,
            },
            parseInt(props.match.params.type)
          )
        );
      } else {
        if (parseInt(props.match.params.searchtype) === 1) {
          getAFuncUsersData();
        } else {
          getAGlobalFuncUserInfo();
        }
      }
    }
  }, [props.match.params.type, userRoles]);

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="mt-3 mb-5 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h3 className="font-weight-bold text-uppercase">
              Personal {props.match.params.name.replaceAll("-", "/")}
            </h3>
            {/* <Form onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                <Col xs="auto">
                  <Form.Control
                    defaultValue={filter}
                    name="search"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                    >
                      <i className="material-icons">visibility</i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form> */}
            <Form onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="search"
                    id="search"
                    defaultValue={filter}
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                    >
                      <i className="material-icons">visibility</i>
                    </Button>
                    <Dropdown className="mx-1">
                      <Dropdown.Toggle
                        variant="light"
                        className="btn-sm font rounded-pill"
                      >
                        <i className="material-icons">filter_list</i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {filters.map((item) => (
                          <Dropdown.Item
                            onClick={() => setTipoBusqueda(item)}
                            key={item.id}
                          >
                            {item.desc}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : data.length > 0 ? (
            <>
              <Row className="mb-4">
                {data.map((item) => (
                  <Col sm={3} className="mb-2">
                    <Link
                      to={`/detalle-empleado/${item.id}/${props.match.params.type}`}
                      className="linkStyle"
                    >
                      <Card className="shadow cards-staff-inventory">
                        <Card.Body>
                          <img
                            src={
                              item.foto
                                ? `${process.env.REACT_APP_URL}/media/${item.foto}`
                                : userperfil
                            }
                            alt="perfil"
                            className="align-items-center text-center image-staff-inventory"
                          />
                          <div className="align-items-center text-center mt-3">
                            <h6 className="m-0 text-uppercase">
                              <small>
                                {item.nombre || "No hay nombre disponible"}
                              </small>
                            </h6>
                            <p className="m-0">
                              <small className="m-0 text-secondary text-capitalize">
                                {item.empresa[0]}
                              </small>
                            </p>
                          </div>
                          <Row className="mt-2">
                            <Col sm={2} xs={2}>
                              <i className="material-icons">perm_phone_msg</i>
                            </Col>
                            <Col sm={10} xs={10}>
                              <small className="m-0 text-secondary">
                                {item.celular
                                  ? item.celular
                                  : item.telefono
                                  ? item.telefono
                                  : "Aún no se ha ingresado"}
                              </small>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={2} xs={2}>
                              <i className="material-icons">mail_outline</i>
                            </Col>
                            <Col sm={10} xs={10}>
                              <small className="m-0 text-secondary">
                                {item.correo_empresarial
                                  ? item.correo_empresarial
                                  : "Aún no ingresado"}
                              </small>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={2} xs={2}>
                              <i className="material-icons">mail_outline</i>
                            </Col>
                            <Col sm={10} xs={10}>
                              <small className="m-0 text-secondary">
                                {item.correo_personal
                                  ? item.correo_personal
                                  : "Aún no ingresado"}
                              </small>
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                    </Link>
                  </Col>
                ))}
              </Row>
              {parseInt(props.match.params.searchtype) === 1 ? (
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={dataLenght}
                  pages={pages}
                  pagFunc={getAFuncUsersData}
                />
              ) : (
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={dataLenght}
                  pages={pages}
                  pagFunc={getAGlobalFuncUserInfo}
                />
              )}
            </>
          ) : !Search && filter !== "" ? (
            <Alert variant="info" className="my-4">
              Empleado no encontrado
            </Alert>
          ) : (
            <Alert variant="info" className="my-4">
              Aún no hay puestos, comienza agregando algunos
            </Alert>
          )}
        </Container>
      </div>
    </>
  );
};

export default FuncStaffInventory;
